<template>
  <v-row>
    <v-col cols="12" md="6">
      <VContactsAutocomplete
        :contact.sync="contact"
        :globalContacts="globalContacts"
        @contactInfo="setContact"
        :role="role || ''"
        :description="description || ''"
      />
    </v-col>

    <ContactForm
      :show="dialog"
      :action="action"
      :values="useData"
      @cancelModal="cancelEdit"
      @updateContact="setContact"
      :contact-title="contactTitle"
    />
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VContactsAutocomplete from '@/components/formfields/VContactsAutocomplete.vue';
import ContactForm from '@/components/dialogs/ContactForm.vue';
import _ from 'lodash';

export default {
  name: "Contact",
  props: {
    d: { type: Object, required: true },
    roles: { type: Array, require: true },
    contactTitle: {
      type: Boolean,
    },
    role: { type: String, required: false },
    description: { type: String, required: false },
  },
  data: () => ({
    action: 'create',
    dialog: false,
    contact: 'New Contact',
    contactData: {},
  }),
  created() {
    this.fetchGlobalContactsList();
  },
  mounted() {
    const vm = this;
    vm.contact = this.d.fullname;
  },
  methods: {
    ...mapActions([
      'fetchGlobalContactsList',
      'updateStoreFormData',
      'updateContactStore',
    ]),
    addNewContact() {
      // prompt user to fill out form
      this.action = 'create';
      this.dialog = true;
    },
    cancelEdit(e) {
      this.contact = '';
      this.dialog = !e;
    },
    setContact(e) {
      this.dialog = false;
      console.log(e);
      this.$set(this.contactData, 'fullname', e.fullname);
      this.$set(this.contactData, 'first', e.first);
      this.$set(this.contactData, 'last', e.last);
      this.$set(this.contactData, 'phone', e.phone);
      this.$set(this.contactData, 'title', e.title);
      this.$set(this.contactData, 'email', e.email);
      let roles = [];
      if (e.roles) {
        roles = _.cloneDeep(e.roles);
      }
      _.forEach(this.roles, (role) => {
        if (_.findIndex(roles, (r) => r === role) === -1) {
          roles.push(role);
        }
      });

      this.$set(this.contactData, 'roles', roles);

      // set contact name
      this.contact = e.fullname;

      // if incomplete data - prompt user to complete the data
      if (!e.fullname || !e.phone || !e.fullname || (this.contactTitle && !e.title)) {
        this.action = 'update';
        this.dialog = true;
      } else {
        this.updateContactStore(_.cloneDeep(this.contactData));
      }
    },
  },
  computed: {
    ...mapGetters(['getFormData', 'getGlobalContactsList']),
    globalContacts() {
      if (this.contactData.fullname && this.contactData.email && this.contactData.phone) {
        const contacts = [...this.getGlobalContactsList];
        contacts.splice(1, 0, this.contactData);
        return contacts;
      }
      return [...this.getGlobalContactsList];
    },
    useData() {
      if (this.contact !== 'New Contact') {
        return this.contactData;
      }
      return {
        fullname: null,
        first: null,
        last: null,
        email: null,
        phone: null,
        title: null,
        roles: [],
      };
    },
  },
  watch: {
    contact(val) {
      if (val === 'New Contact') {
        this.addNewContact();
      }
    },
    contactData: {
      handler(val) {
        this.$emit('assignContact', val);
      },
      deep: true,
    },
  },
  components: {
    VContactsAutocomplete,
    ContactForm,
  },
};
</script>
